import AxiosClient from "../../services/axios.services";

class SpecializationServices {
  getSpecializations = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Especialidad/"
        : "/api/app/Funcional_Especialidad/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveSpecialization = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Especialidad/"
        : "/api/app/Funcional_Especialidad/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editSpecialization = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Especialidad/${id}/`
        : `/api/app/Funcional_Especialidad/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteSpecialization = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Especialidad/${id}/`
        : `/api/app/Funcional_Especialidad/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new SpecializationServices();
